import React, { FC } from 'react'

import { Box } from '@mui/material'
import { isEmpty } from 'lodash'
import orderBy from 'lodash/orderBy'
import { useTranslation } from 'react-i18next'

import { HorizontalBarItemData, HorizontalMultiBar } from '../../../components/HorizontalMultiBar'
import { SortDirection } from '../../../types'
import { EmptyData } from '../EmptyData'
import { Indicators } from '../Indicators'
import { ReportWidgetsHeader } from '../ReportWidgetsHeader'
import { StyledWidgetWrapper } from '../StyledWidgetWrapper'
import { TopInstrumentByLevelOfStressType } from '../types'

export const LevelOfStressWidget: FC<{ levelData: TopInstrumentByLevelOfStressType[] }> = ({
  levelData,
}) => {
  const { t } = useTranslation()

  const maxNumberOfItemsPerWidget = 6

  const normalizedData = orderBy(levelData, 'percentages', SortDirection.desc).slice(
    0,
    maxNumberOfItemsPerWidget,
  )

  const barData: HorizontalBarItemData[] = normalizedData.map(({ symbol, perCent }) => ({
    parameter: symbol.toUpperCase().replace(/(.{3})/, '$1/'),
    value: perCent,
  }))

  return (
    <StyledWidgetWrapper>
      <ReportWidgetsHeader
        text={t('topInstrumentsByLevelOfStress', 'Top instruments by level of stress')}
        explanation={t(
          'theGraphRepresentsWhatAreTheMostStressfulInstruments',
          'The graph represents what are the most stressful instruments',
        )}
      >
        <Indicators
          positiveLabel={t('low', 'Low')}
          negativeLabel={t('high', 'High')}
          middleLabel={t('mid', 'Mid') as string}
        />
      </ReportWidgetsHeader>

      <Box mt={4}>
        {isEmpty(levelData) ? (
          <EmptyData
            title={t('notEnoughData', 'Not enough data')}
            subtitle={t('pleaseCompleteJournalingSection', 'Please complete "Journaling" section')}
          />
        ) : (
          <HorizontalMultiBar
            data={barData}
            maxZonePresents={60}
            minZonePresents={30}
            percentType
          />
        )}
      </Box>
    </StyledWidgetWrapper>
  )
}
